import React, { Suspense, useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { Await, useLoaderData } from 'react-router-dom'

import LoadingSpinner, { SpinnerSize } from '@components/shared/LoadingSpinner'
import NFIcon from '@components/shared/NFIcon'
import Divider from '@layout/Divider'
import MenuItem from '@layout/MenuItem'
import { useSession } from '@stores/globalData/globalData.store'

import type { HomeLoaderResponse } from '@pages/home/loaders/home.loader'

const RedeemedContentMenu: React.FC = () => {
  const data = useLoaderData() as HomeLoaderResponse
  const { t } = useTranslation()
  const session = useSession()

  const shouldShow = useMemo(
    () => session.gatedFeatures.showGatedFeature('bookDemoUsers'),
    [session]
  )

  if (!shouldShow) {
    return null
  }
  return (
    <>
      <p className="font-medium px-1.5 mt-2.5 mb-2">{t('titles.redeemedContent')}</p>
      <Suspense fallback={<LoadingSpinner size={SpinnerSize.SMALL} />}>
        <Await resolve={data.redeemedContent}>
          {({ redemptions }) =>
            redemptions.map((content) => (
              <MenuItem
                key={`redeemed-content-${content.id}`}
                label={content.title}
                to={`/home/redeemedContent/${content.id}`}
                icon={<NFIcon icon="book" className="text-xl" />}
                className="mb-1"
              />
            ))
          }
        </Await>
      </Suspense>
      <Divider dark narrow />
    </>
  )
}

export default RedeemedContentMenu
